module.exports = __webpack_public_path__ + "img/casitaMobile.3c3ff10d.svg";